import React from 'react';
import './SubNav.scss';
import { subNavData } from './subNavData.js';
const url = 'https://www.cnn.com/';

function SubNav({ origin }) {
  return (
    <nav className={`subnav subnav-${origin}`}>
      {origin === 'main' && (
        <a
          href="https://www.cnn.com/"
          aria-label="CNN"
          data-analytics="footer"
          className="subnav__logo"
        >
          <svg
            className="cnn-badge-icon"
            viewBox="0 0 240 240"
            fill="#CC0000"
            xmlns="https://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <rect x="0" y="0" width="100%" height="100%" fill="#fff"></rect>
            <path
              d="M.31-.07v240h240V-.07ZM86.54,135.29V92.51c0-16.1,20.81-23.83,31.82-5.12.8,1.35,18.14,31.22,18.14,31.22V92.51c0-16.1,20.8-23.83,31.81-5.12.8,1.35,18.14,31.22,18.14,31.22V76.79h10.38V147a2.11,2.11,0,0,1-1.51,2.14c-1.1.3-2.26-.38-3.11-1.82-.17-.28-9-15.46-17.48-30.13L159.17,90.4c-2.18-3.7-5.43-4.35-7.74-3.72a6.23,6.23,0,0,0-4.55,6.13V147a2.12,2.12,0,0,1-1.51,2.14c-1.11.3-2.27-.38-3.11-1.82-.15-.25-8.34-14.36-16.25-28-10.08-17.38-16.7-28.78-16.8-28.95-2.18-3.71-5.44-4.35-7.77-3.72a6.24,6.24,0,0,0-4.56,6.13v53.05a2.9,2.9,0,0,1-2.72,2.71H67.23a28.64,28.64,0,0,1,0-57.28h14v10.36H67.35a18.28,18.28,0,1,0,0,36.56H83.68A2.84,2.84,0,0,0,86.54,135.29Zm124.77,12.05c0,16.1-20.81,23.83-31.82,5.13-.79-1.35-18.14-31.23-18.14-31.23v26.1c0,16.1-20.8,23.83-31.81,5.13-.8-1.35-18.14-31.23-18.14-31.23v24.61c0,11.17-6.63,17.22-17,17.22H67.25a43.14,43.14,0,0,1,0-86.28h14V87.15h-14a32.78,32.78,0,1,0,0,65.56H94.16a7,7,0,0,0,6.86-6.85V92.81a2.1,2.1,0,0,1,1.51-2.13c1.1-.3,2.26.38,3.11,1.82l16.79,28.93c9.76,16.83,16.17,27.88,16.25,28,2.19,3.7,5.45,4.35,7.78,3.71A6.22,6.22,0,0,0,151,147V92.82a2.11,2.11,0,0,1,1.49-2.14c1.09-.3,2.24.38,3.08,1.82l15.56,26.81,17.49,30.15c1.71,2.9,4.09,3.93,6.16,3.93a6,6,0,0,0,1.61-.22A6.23,6.23,0,0,0,201,147V76.79h10.34Z"
              transform="translate(-0.31 0.07)"
            ></path>
          </svg>
        </a>
      )}
      {subNavData[origin] &&
        subNavData[origin].map((link, i) => {
          return (
            <div className="subnav__section" key={i}>
              {link.url.includes('https') ? (
                <a className="subnav__section__title" href={link.url}>
                  {link.title}
                </a>
              ) : (
                <a className="subnav__section__title" href={`${url}${link.url}`}>
                  {link.title}
                </a>
              )}
              <ul className="subnav__section__list">
                {link.sublinks &&
                  link.sublinks.map((sublink, i) => {
                    return (
                      <li className="subnav__section__listItem" key={i}>
                        {sublink.url.includes('https') ? (
                          <a className="subnav__section__listItem-item" href={sublink.url}>
                            {sublink.title}
                          </a>
                        ) : (
                          <a
                            className="subnav__section__listItem-item"
                            href={`${url}${sublink.url}`}
                          >
                            {sublink.title}
                          </a>
                        )}
                      </li>
                    );
                  })}
              </ul>
            </div>
          );
        })}
    </nav>
  );
}

export default SubNav;
